// Mock data for Enciso Landscape Services LLC

export const companyInfo = {
  name: "Enciso Landscape Services",
  fullName: "Enciso Landscape Services, LLC",
  phone: "229-300-2085",
  email: "ernesto.landscapeservice@gmail.com",
  address: "905 Howell Rd, Valdosta, GA 31601",
  serviceArea: "Servicing Georgia & Florida",
  logo: "https://customer-assets.emergentagent.com/job_ba302bff-8f4a-4361-9d34-140c928961c0/artifacts/7gtlx09a_ALL%20WHITE%20NO%20PHONE%20NUMBER.jpg",
  yearsExperience: 20,
};

export const aboutContent = {
  title: "About Enciso Landscape Services, LLC",
  description: `Enciso Landscape Services, LLC is a professional landscaping company with over 20 years of industry experience, providing reliable, high-quality services for both residential and commercial properties. Our team brings proven expertise, attention to detail, and a strong commitment to customer satisfaction on every job.

We offer a full range of landscaping services, including irrigation installation and repair, lawn care maintenance, planting, mulching, sod installation, and seasonal cleanups. We also specialize in residential hardscape design, landscape lighting, and effective drainage solutions to enhance the beauty and functionality of outdoor spaces.

From routine maintenance such as trimming, edging, and blowing to professional tree and shrub care, we focus on maintaining healthy landscapes that look great year-round.

At Enciso Landscape Services, LLC, we take pride in dependable service, clear communication, and quality workmanship. Whether managing a commercial property or improving a residential landscape, our goal is to deliver results you can trust and outdoor spaces you can be proud of.`,
};

export const heroSlides = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1558904541-efa843a96f01?w=1920&q=80",
    title: "Professional Landscaping Services",
    subtitle: "Transform your outdoor space with over 20 years of expertise",
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1585428311604-98738fc5687a?w=1920&q=80",
    title: "Beautiful Southern Landscapes",
    subtitle: "Creating stunning outdoor environments for Georgia & Florida homes",
  },
  {
    id: 3,
    image: "https://images.pexels.com/photos/280222/pexels-photo-280222.jpeg?w=1920&q=80",
    title: "Commercial & Residential Excellence",
    subtitle: "Professional lawn care for properties of all sizes",
  },
];

export const services = [
  {
    id: "irrigation-install",
    title: "Irrigation Installation",
    shortDesc: "Professional sprinkler system design and installation",
    description: "Complete irrigation system design and installation for efficient watering of your landscape. We use quality materials and proven techniques to ensure optimal coverage and water conservation for Georgia and Florida properties.",
    icon: "Droplets",
    image: "https://customer-assets.emergentagent.com/job_ba302bff-8f4a-4361-9d34-140c928961c0/artifacts/lx4szcf1_image.png",
    gallery: [
      "https://customer-assets.emergentagent.com/job_ba302bff-8f4a-4361-9d34-140c928961c0/artifacts/lx4szcf1_image.png",
    ],
  },
  {
    id: "irrigation-repair",
    title: "Irrigation Repair",
    shortDesc: "Fast, reliable sprinkler system repairs",
    description: "Quick diagnosis and repair of broken sprinkler heads, leaks, controller issues, and valve problems. We keep your irrigation system running efficiently in the hot Southern climate.",
    icon: "Wrench",
    image: "https://customer-assets.emergentagent.com/job_ba302bff-8f4a-4361-9d34-140c928961c0/artifacts/l0l3ha64_image.png",
    gallery: [
      "https://customer-assets.emergentagent.com/job_ba302bff-8f4a-4361-9d34-140c928961c0/artifacts/l0l3ha64_image.png",
    ],
  },
  {
    id: "lawn-maintenance",
    title: "Lawn Care Maintenance",
    shortDesc: "Complete lawn care for a healthy, green yard",
    description: "Regular mowing, fertilization, weed control, and lawn health management to keep your St. Augustine, Bermuda, or Zoysia grass looking its best throughout the seasons.",
    icon: "Scissors",
    image: "https://customer-assets.emergentagent.com/job_ba302bff-8f4a-4361-9d34-140c928961c0/artifacts/k43xez9q_image.png",
    gallery: [
      "https://customer-assets.emergentagent.com/job_ba302bff-8f4a-4361-9d34-140c928961c0/artifacts/k43xez9q_image.png",
    ],
  },
  {
    id: "landscape-lighting",
    title: "Landscape Lighting",
    shortDesc: "Illuminate your outdoor spaces beautifully",
    description: "Professional outdoor lighting design and installation to enhance safety, security, and the beauty of your Southern property after dark.",
    icon: "Lightbulb",
    image: "https://customer-assets.emergentagent.com/job_ba302bff-8f4a-4361-9d34-140c928961c0/artifacts/u816r5y8_image.png",
    gallery: [
      "https://customer-assets.emergentagent.com/job_ba302bff-8f4a-4361-9d34-140c928961c0/artifacts/u816r5y8_image.png",
    ],
  },
  {
    id: "hardscape-design",
    title: "Hardscape Design",
    shortDesc: "Custom patios, walkways, and outdoor living spaces",
    description: "Transform your outdoor space with beautiful hardscape features including patios, walkways, retaining walls, and outdoor living areas perfect for the Georgia and Florida lifestyle.",
    icon: "LayoutGrid",
    image: "https://images.unsplash.com/photo-1761637822930-fb1c1a3df94d?w=800&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1761637822930-fb1c1a3df94d?w=800&q=80",
    ],
  },
  {
    id: "planting",
    title: "Planting",
    shortDesc: "Expert plant selection and installation",
    description: "Professional planting services including palms, azaleas, camellias, ornamental grasses, and native plants selected specifically for the Georgia and Florida climate.",
    icon: "Flower2",
    image: "https://customer-assets.emergentagent.com/job_ba302bff-8f4a-4361-9d34-140c928961c0/artifacts/gg3woux2_image.png",
    gallery: [
      "https://customer-assets.emergentagent.com/job_ba302bff-8f4a-4361-9d34-140c928961c0/artifacts/gg3woux2_image.png",
    ],
  },
  {
    id: "mulching",
    title: "Mulching",
    shortDesc: "Quality mulch installation for healthier beds",
    description: "Professional mulch installation to improve soil health, retain moisture in the hot Southern summers, suppress weeds, and enhance the appearance of your garden beds.",
    icon: "Layers",
    image: "https://customer-assets.emergentagent.com/job_ba302bff-8f4a-4361-9d34-140c928961c0/artifacts/qgvag9kj_image.png",
    gallery: [
      "https://customer-assets.emergentagent.com/job_ba302bff-8f4a-4361-9d34-140c928961c0/artifacts/qgvag9kj_image.png",
    ],
  },
  {
    id: "sod-installation",
    title: "Sod Installation",
    shortDesc: "Instant lawn transformation with quality sod",
    description: "Transform bare or damaged areas into lush, green lawns instantly with our professional sod installation. We work with St. Augustine, Bermuda, Zoysia, and other Southern turf varieties.",
    icon: "Leaf",
    image: "https://customer-assets.emergentagent.com/job_ba302bff-8f4a-4361-9d34-140c928961c0/artifacts/6myrs0w2_image.png",
    gallery: [
      "https://customer-assets.emergentagent.com/job_ba302bff-8f4a-4361-9d34-140c928961c0/artifacts/6myrs0w2_image.png",
    ],
  },
  {
    id: "drainage-solutions",
    title: "Drainage Solutions",
    shortDesc: "Effective water management for your property",
    description: "Solve water drainage problems common in Georgia and Florida with French drains, channel drains, grading, and other solutions to protect your landscape and property from heavy rains.",
    icon: "Waves",
    image: "https://customer-assets.emergentagent.com/job_ba302bff-8f4a-4361-9d34-140c928961c0/artifacts/bk3g7vfo_image.png",
    gallery: [
      "https://customer-assets.emergentagent.com/job_ba302bff-8f4a-4361-9d34-140c928961c0/artifacts/bk3g7vfo_image.png",
    ],
  },
  {
    id: "seasonal-cleanups",
    title: "Seasonal Cleanups",
    shortDesc: "Complete seasonal property maintenance",
    description: "Prepare your property for each season with our comprehensive cleanup services including leaf removal, bed cleanup, pine straw refreshing, and debris clearing.",
    icon: "CalendarDays",
    image: "https://images.unsplash.com/photo-1605117882932-f9e32b03fea9?w=800&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1605117882932-f9e32b03fea9?w=800&q=80",
    ],
  },
  {
    id: "tree-shrub-care",
    title: "Tree & Shrub Care",
    shortDesc: "Professional tree and shrub maintenance",
    description: "Complete tree and shrub care including pruning, disease treatment, fertilization, and palm tree maintenance to keep your Southern landscape healthy and beautiful.",
    icon: "TreePine",
    image: "https://customer-assets.emergentagent.com/job_ba302bff-8f4a-4361-9d34-140c928961c0/artifacts/9ioiw0ix_image.png",
    gallery: [
      "https://customer-assets.emergentagent.com/job_ba302bff-8f4a-4361-9d34-140c928961c0/artifacts/9ioiw0ix_image.png",
    ],
  },
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah M.",
    location: "Valdosta, GA",
    text: "Enciso Landscape Services transformed our backyard! Their attention to detail and professionalism exceeded our expectations.",
    rating: 5,
  },
  {
    id: 2,
    name: "Robert J.",
    location: "Tallahassee, FL",
    text: "We've used their lawn maintenance services for over a year now. Always reliable, always professional. Highly recommend!",
    rating: 5,
  },
  {
    id: 3,
    name: "Commercial Property Manager",
    location: "Albany, GA",
    text: "Outstanding commercial landscaping services. They keep our properties looking immaculate year-round.",
    rating: 5,
  },
];
